import type { Carrier } from '@klareospace/pharos-lib-types';
import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { carrierKeys, createCarrierApi } from '../api';

export function useCarrier(carrierId: string | undefined): UseQueryResult<Carrier, Error> {
  const client = useApiClient('admin-auth');
  const api = createCarrierApi(client);

  return useQuery({
    enabled: !!carrierId,
    queryFn: () => api.getCarrier(carrierId as string),
    queryKey: carrierKeys.detail(carrierId ?? ''),
  });
}
